import React from 'react';
import styles from './AreaField.module.scss';
import classNames from 'classnames';

type PropsType = {
  name: string;
  cols?: number;
  rows?: number;
  id?: string;
  className?: string;
  errors?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  placeholder?: string;
  ariaLabel?: string;
  onChange?: (value: string, e: any) => void;
};

const AreaField = (props: PropsType) => {
  const handleChange = (e: any) => {
    if (props.onChange) {
      props.onChange(e.target.value, e);
    }
  };

  return (
    <>
      {props.defaultValue ? (
        <textarea
          cols={props.cols}
          rows={props.rows}
          name={props.name}
          id={props.id ? props.id : 'publicKey'}
          className={classNames(
            styles.textarea,
            props.className,
            props.disabled && styles.textareaDisabled
          )}
          value={props.value}
          defaultValue={props.defaultValue}
          onChange={handleChange}
          disabled={props.disabled}
          placeholder={props.placeholder}
          aria-label={props.ariaLabel}
        />
      ) : (
        <textarea
          cols={props.cols}
          rows={props.rows}
          name={props.name}
          id={props.id ? props.id : 'publicKey'}
          className={classNames(
            styles.textarea,
            props.className,
            props.disabled && styles.textareaDisabled
          )}
          value={props.value}
          onChange={handleChange}
          disabled={props.disabled}
          placeholder={props.placeholder}
          aria-label={props.ariaLabel}
        />
      )}

      {props.errors && <div className={styles.errorField}>{props.errors}</div>}
    </>
  );
};

export default AreaField;
